"use client"

import Link from "next/link"
import { useLanguage } from "@/contexts/language-context"

export default function Footer() {
  const { t } = useLanguage()

  return (
    <footer className="border-t bg-muted/40">
      <div className="container mx-auto px-4 py-8 md:px-6">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div className="space-y-3 flex-1">
            <div className="flex items-center space-x-2">
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-amber-500">
                <span className="font-bold text-white">L</span>
              </div>
              <span className="font-bold text-lg">Lunabrush AI</span>
            </div>
            <p className="text-sm text-muted-foreground">{t("footerDesc")}</p>
            <div className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} • {t("allRightsReserved")}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-8 md:gap-16">
            <div className="space-y-3">
              <h3 className="font-medium">{t("tools")}</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link href="/create" className="text-muted-foreground hover:text-foreground">
                    {t("aiGenerator")}
                  </Link>
                </li>
                <li>
                  <Link href="/gallery" className="text-muted-foreground hover:text-foreground">
                    {t("imageGallery")}
                  </Link>
                </li>
              </ul>
            </div>

            <div className="space-y-3">
              <h3 className="font-medium">{t("support")}</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link href="/terms" className="text-muted-foreground hover:text-foreground">
                    {t("termsOfService")}
                  </Link>
                </li>
                <li>
                  <Link href="/privacy" className="text-muted-foreground hover:text-foreground">
                    {t("privacyPolicy")}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
